$('document').ready(function(){
  //Timeout
setTimeout(() => {
  //get URL 
  var inUrl = window.location.href;
  const arrayUrl = inUrl.split("/");

  if (typeof arrayUrl[5] !== 'undefined') {

    const selectedIndexes = arrayUrl[5].split("-");

    var i = 0;            
      //Loop all of the select boxes inside the .mw-product-options div                 
      for(let select_box_wrapper of document.querySelectorAll('.mw-option--type-select')){
          //If its hidden, skip it
          if(select_box_wrapper.classList.contains('mw-hidden')) continue;
          //Get the select box
          let select_box = select_box_wrapper.querySelector('select.mws-new_select');
          //Select the option index
          let select_value = select_box.options[selectedIndexes[i]].value;
          $(select_box_wrapper).find(`.selectCustom div[data-value="${select_value}"]`).trigger('click');
          i=i+1;
      }
    
  }
}, 500);
});

/* $('document').ready(function(){
  	//get URL 
  	var inUrl = window.location.href;
  	const arrayUrl = inUrl.split("/");
  
  	if (typeof arrayUrl[5] !== 'undefined') {
  
      const selectedIndexes = arrayUrl[5].split("-");


      //Start an observer timeout
      var observeTimeout = 0;

      //Grab the element we want to observe
      let observe_element = document.querySelector('.mw-product-options');

      //If there is an element to observe
      if(observe_element){

        // New observer, this is the code that runs when our DOM changes and the product attributes load
        let product_attribute_observer = new MutationObserver(mutationRecords => {

          //Clear the observer timeout, we're still changing
          clearTimeout(observeTimeout);

          //Set a new timeout
          observeTimeout = setTimeout(() =>{
              var i = 0;            
              //Loop all of the select boxes inside the .mw-product-options div                 
              for(let select_box of document.querySelectorAll('.mw-product-options select')){
                  //If the option is disabled, find its visible partner
                  if(select_box.options[selectedIndexes[i]].disabled){
                    let pairedOption = select_box.querySelector(`option[value="${select_box.options[selectedIndexes[i]].value}"]:not([disabled="disabled"])`);
                    select_box.value = pairedOption.value;
                    pairedOption.checked = true;
                    pairedOption.selected = true;
                  } else {
                    select_box.value = select_box.options[selectedIndexes[i]].value;
                    select_box.options[selectedIndexes[i]].checked = true;
                    select_box.options[selectedIndexes[i]].selected = true;
                  }

                  $(select_box).trigger('change');
                  i=i+1;
              }


            //Disconnect, we're done
            product_attribute_observer.disconnect();

          },500);

        });

        // observe everything except attributes
        product_attribute_observer.observe(observe_element, { childList: true });

      }
  	  
    }
  
}); */